<div class="">
  <div class="bg-white p-3 w-full shadow-md">
    <div class="flex items-center mb-2">
      <button class="bg-gradient2 mr-2 py-1 px-2 rounded-md" (click)="goBack()">
        <mat-icon svgIcon="back"></mat-icon>
      </button>
      <span class="text-[20px] text-primary-500" style="font-weight: bolder;">Notifications Center</span>
    </div>
  </div>

  <div class="flex w-full items-center justify-center">
    <div class="w-2/3 mt-3">
      <div class="mb-5 mt-2 flex items-center">
        <span class="mr-2 text-primary-500" style="font-weight: bolder;">Filters</span>

        <select class="w-20 p-1 mr-2 rounded-md">
          <option>All</option>
          <option>Unread</option>
          <option>Read</option>
        </select>

        <span class="mr-2 text-primary-500" style="font-weight: bolder;">From:</span>
        <input type="date" class="w-32 p-2 mr-2 rounded-md">

        <span class="mr-2 text-primary-500" style="font-weight: bolder;">To:</span>
        <input type="date" class="w-32 p-2 mr-2 rounded-md">
      </div>

      <div class="mb-1 text-gray-500">
        <span>Today</span>
      </div>
      <div class="p-3">
        <div class="bg-[#6484FF] bg-opacity-5 mb-2 shadow-sm rounded-md flex items-center justify-between p-3">
          <div class="flex justify-start items-center">
            <div class="bg-[#6484FF] bg-opacity-20 flex items-center justify-center rounded-full mr-3"
              style="height: 60px; width: 60px;">
              <mat-icon svgIcon="infoicon" style="height: 40px; width: 40px;"></mat-icon>
            </div>
            <div class="py-1 flex flex-col">
              <span class="text-primary-500"
                style="font-size: 16px; font-weight: bolder; line-height: 1;">Information</span>
              <span style="font-size: 15px;">Action description ...</span>
            </div>
          </div>

          <div>
            <span class="text-[#B0AEAE]">12:30PM</span>
          </div>
        </div>

        <div class="bg-white mb-2 shadow-sm rounded-md flex items-center justify-between p-3">
          <div class="flex justify-start items-center">
            <div class="bg-[#6484FF] bg-opacity-10 flex items-center justify-center rounded-full mr-3"
              style="height: 60px; width: 60px;">
              <mat-icon svgIcon="infoicon" style="height: 40px; width: 40px;"></mat-icon>
            </div>
            <div class="py-1 flex flex-col">
              <span class="text-primary-500"
                style="font-size: 16px; font-weight: bolder; line-height: 1;">Information</span>
              <span style="font-size: 15px;">Action description ...</span>
            </div>
          </div>

          <div>
            <span class="text-[#B0AEAE]">11:40AM</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>